import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "./servicessection.css";

import img1 from "../../assets/dsigniibgimage/img7.jpeg";
import img2 from "../../assets/dsigniibgimage/img2.jpg";
import img3 from "../../assets/dsigniibgimage/img3.jpeg";
import img4 from "../../assets/dsigniibgimage/img6.jpeg";
import img5 from "../../assets/dsigniibgimage/img5.jpeg";
import img6 from "../../assets/dsigniibgimage/img1.jpg";

function ServicesSection() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });

    // Detect mobile screen size
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    handleResize(); // Run on mount
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleCall = () => {
    window.location.href = "tel:8778934301"; // opens phone dialer
  };


  const designData = [
    {
      image: img5,
      title: "Web Development",
      desc: "Crafting responsive, high-performance websites tailored to your business goals — delivering seamless user experiences, scalable growth, and modern designs optimized for every device.",
    },
    {
      image: img1,
      title: "Digital Marketing",
      desc: "Data-driven strategies that fuel growth, enhance brand visibility, and increase ROI across online channels including SEO, social media, and paid campaigns.",
    },
    {
      image: img2,
      title: "Logo Design",
      desc: "Memorable and meaningful logos that reflect your brand identity, communicate your values, and create a lasting first impression.",
    },
    {
      image: img3,
      title: "E-commerce Website",
      desc: "Robust, user-friendly online stores designed to convert visitors into loyal customers with secure checkout, product management, and smooth navigation.",
    },
    {
      image: img4,
      title: "Business Website",
      desc: "Clean, modern layouts tailored to elevate your brand, support your business goals, and engage clients with a professional online presence.",
    },
    {
      image: img6,
      title: "Education Website",
      desc: "Interactive, scalable learning environments designed for schools, tutors, and e-learning providers with easy content management and engaging interfaces.",
    },
  ];

  return (
    
    <section className="services-section">
      <div className="container">
        <section className="section-margin">
          <div className="heading-for-all" data-aos="fade-up">
            <h2>Our Services</h2>
          </div>
        </section>

        {/* ✅ Show Swiper only on mobile */}
        {isMobile ? (
          <div className="services-swiper">
            <Swiper
              modules={[Autoplay, Pagination]}
              spaceBetween={20}
              slidesPerView={1}
              autoplay={{
                delay: 2500,
                disableOnInteraction: false,
              }}
              pagination={{ clickable: true }}
              loop={true}
            >
              {designData.map((service, index) => (
                <SwiperSlide key={index}>
                  <div
                    className="service-card"
                    data-aos="fade-up"
                    data-aos-delay={index * 150}
                  >
                    <div className="service-icon">
                      <img
                        src={service.image}
                        className="image-section"
                        alt={service.title}
                      />
                    </div>
                    <h3 className="service-title">{service.title}</h3>
                    <p className="service-description">{service.desc}</p>
                    <button className="card-button" onClick={handleCall}>More info</button>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        ) : (
          /* ✅ Show normal grid on desktop */
          <div className="services-grid">
            {designData.map((service, index) => (
              <div
                key={index}
                className="service-card"
                data-aos="fade-up"
                data-aos-delay={index * 150}
              >
                <div className="service-icon">
                  <img
                    src={service.image}
                    className="image-section"
                    alt={service.title}
                  />
                </div>
                <h3 className="service-title">{service.title}</h3>
                <p className="service-description">{service.desc}</p>
                <button className="card-button"  onClick={handleCall}>More info</button>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}

export default ServicesSection;
